/* CE Keepsake — reveal animations + sticky mobile CTA.
   Idempotent: sections may each include this script tag; it runs once. */
(function () {
  if (window.__ceKeepsakeInit) return;
  window.__ceKeepsakeInit = true;

  /* In the theme editor, sections re-render on every tweak and IO targets
     would stay hidden — skip the reveal gate entirely there. */
  var designMode = (window.Shopify && window.Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode');
  if (!designMode) {
    document.documentElement.classList.add('ce-k-js');
  }

  function init() {
    var reveals = document.querySelectorAll('.k-reveal');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* sticky mobile CTA: show once the hero has scrolled out */
    var hero = document.querySelector('.k-hero');
    var sticky = document.getElementById('k-sticky');
    if (hero && sticky && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-shown', !entries[0].isIntersecting);
      }, { rootMargin: '0px' });
      sio.observe(hero);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.k-reveal').forEach(function (el) { el.classList.add('is-in'); });
    init();
  });
})();
